import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🕊️ ¿Qué agrega el{' '}
            <span className="text-[#00E676]" data-id="element-78">
              Bio-Inclusión Pack™ (Adaptaciones al Aula)
            </span>
            ?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés el material para el 80% del aula. El MegaPack +
            Adaptaciones resuelve el 20% que más tiempo te consume.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00E676]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d08] border-b border-[#00E676]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00E676]/30" data-id="element-83">
              Sin Adaptaciones
            </div>
            <div className="p-4 font-bold text-[#00E676] text-center border-l border-[#00E676]/30" data-id="element-84">
              Con Adaptaciones
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Valentina tiene PPI y no puede hacer la actividad estándar
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Adaptaciones:
              </span>
              Improvisás algo "más fácil" en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00E676]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#00E676] block mb-1" data-id="element-91">
                Con Adaptaciones:
              </span>
              Imprimís la versión espejo. 30 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Marco necesita el examen diferente el día del trimestral
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Adaptaciones:
              </span>
              Armás otro examen el domingo a la noche
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00E676]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#00E676] block mb-1" data-id="element-98">
                Con Adaptaciones:
              </span>
              Abrís el banco de evaluaciones PPI. Ya está listo.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              La inspectora pide ver el registro de adecuaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Adaptaciones:
              </span>
              Buscás algo que no encontrás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00E676]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#00E676] block mb-1" data-id="element-105">
                Con Adaptaciones:
              </span>
              Mostrás la plantilla de legajo firmada. Profesional.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              La MAI te pregunta cómo va el alumno integrado
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Adaptaciones:
              </span>
              Improvisás una respuesta
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00E676]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#00E676] block mb-1" data-id="element-112">
                Con Adaptaciones:
              </span>
              Completás el informe en 5 minutos con la plantilla.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-113">
          ✅ EL BIO-INCLUSIÓN PACK™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-114">
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-115">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-116">
              30 Secuencias Espejo
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-117">
              Versión simplificada de los temas centrales de cada año. Mismo
              contenido, menor carga cognitiva.
            </p>
          </div>
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-118">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-119">
              18 Evaluaciones Visuales PPI
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-120">
              Formato accesible: opción múltiple, unir con flechas, completar
              con recuadro, señalar en imagen.
            </p>
          </div>
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-121">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-122">
              Kit Administrativo
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-123">
              4 plantillas de legajo listas para firmar: Registro de
              adecuaciones / Informe trimestral / Acuerdo con familia / Nota
              rápida.
            </p>
          </div>
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-124">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-125">
              Glosario en Pictogramas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-126">
              40 conceptos clave de Biología representados con íconos y
              definición simplificada. Para tener sobre el banco durante las
              clases.
            </p>
          </div>
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-127">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-128">
              Sistema de Adaptación Express
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-129">
              Método de 3 pasos para transformar cualquier consigna del MegaPack
              en versión accesible en menos de 2 minutos.
            </p>
          </div>
          <div className="bg-black border border-[#00E676]/20 rounded-xl p-5" data-id="element-130">
            <h4 className="text-[#00E676] font-bold text-lg mb-2" data-id="element-131">
              5 Estrategias de Aula Heterogénea
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-132">
              Cómo implementar las dos versiones del material sin que el aula se
              divida en "los que pueden" y "los que no".
            </p>
          </div>
        </div>
      </div>
    </section>;
}